import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { TherapistApi, TherapistAreaApi } from "@/Modules/Models/Api/Therapist";
import type {
  Therapist,
  TherapistArea,
  TherapistCurrent,
  TherapistEducation,
  AdditionalLanguage,
} from "@/Modules/Models/Domain/Therapist";

import camelize from "@/Utils/Camelize";
import { camel } from "@/Utils/Camelize";

class TherapistApiToTherapistTransformer implements Transformer<TherapistApi, Therapist> {
  transform(therapistApi: TherapistApi): Therapist {
    const areas: TherapistArea[] = therapistApi.areas.map((area) => {
      return camelize<TherapistAreaApi>(area, [
        "area_i18n",
        "area_id",
        "country",
        "is_active",
        "sub_area_i18n",
        "sub_area_id",
      ]) as TherapistArea;
    });

    const currents: TherapistCurrent[] = therapistApi.currents?.map((current) => {
      return camel(current);
    });

    const educations: TherapistEducation[] = therapistApi.educations?.map((education) => {
      return camel(education);
    });

    const additionalLanguages = camel(therapistApi.additional_languages) as AdditionalLanguage[];

    const therapist: Therapist = {
      ...(camelize<TherapistApi, Therapist>(
        therapistApi,
        [
          "ccc",
          "uuid",
          "therapist_license_number",
          "availability",
          "capacity_afternoon",
          "capacity_morning",
          "capacity_updated",
          "fast_assignment",
          "stripe_account_status",
          "is_stripe_connect_available",
          "is_trp_enabled",
          "nif",
          "is_edit_profile_popup",
          "trp_level_changed",
          "prev_trp_level",
          "level",
          "is_transcription_available",
          "min_price_per_session",
          "calendar_integrations",
          "maia_agent_enabled",
        ],
        ["iban", "id", "licenseNumber"]
      ) as Omit<Therapist, "areas">),
      areas,
      currents,
      educations,
      additionalLanguages,
    };

    return therapist;
  }
}

export default TherapistApiToTherapistTransformer;
